import { useState, useEffect } from 'react';

export function RequestSeatModal({ visible, onClose, onSubmit, loading, listing }) {
  const [note, setNote] = useState('');

  useEffect(() => {
    if (!visible) {
      setNote('');
    }
  }, [visible]);

  const handleSubmit = () => {
    onSubmit?.({ note: note.trim() });
  };

  if (!visible) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-end justify-center bg-black/45 backdrop-blur-sm sm:items-center"
      onClick={e => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        className="w-full max-w-md rounded-t-2xl bg-white p-6 shadow-2xl dark:bg-slate-900 sm:rounded-2xl"
        onClick={e => e.stopPropagation()}
      >
        <h2 className="mb-4 text-lg font-bold text-gray-900 dark:text-white">
          Apply for seat
        </h2>

        <div className="space-y-4">
          <div>
            <label className="mb-1.5 block text-xs font-semibold text-gray-600 dark:text-slate-400">
              Note (optional)
            </label>
            <textarea
              value={note}
              onChange={e => setNote(e.target.value)}
              placeholder="Add a message..."
              rows={4}
              className="w-full rounded-xl border border-gray-200 bg-gray-50 px-3 py-2 text-sm text-gray-900 placeholder-gray-400 transition focus:border-yellow-400 focus:bg-white focus:outline-none dark:border-slate-700 dark:bg-slate-800 dark:text-white dark:placeholder-slate-500 dark:focus:border-yellow-400"
            />
          </div>
        </div>

        <div className="mt-6 flex gap-3">
          <button
            type="button"
            onClick={onClose}
            disabled={loading}
            className="flex-1 rounded-xl bg-gray-100 px-4 py-2.5 text-sm font-semibold text-gray-900 transition hover:bg-gray-200 disabled:opacity-50 dark:bg-slate-800 dark:text-white dark:hover:bg-slate-700"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleSubmit}
            disabled={loading}
            className="flex-1 rounded-xl bg-yellow-400 px-4 py-2.5 text-sm font-extrabold text-black transition hover:bg-yellow-300 disabled:opacity-50"
          >
            {loading ? 'Submitting...' : 'Apply'}
          </button>
        </div>
      </div>
    </div>
  );
}

